module.exports = __webpack_public_path__ + "static/media/webd3.f7b4bf12.jpg";